<template>
  <div class="product_goods_list">
    <vs-breadcrumb
      class="mb-6"
      :items="[
        {
          title: '商品',
          url: '/goods/list',
        },
        {
          title: '商品列表',
          active: true,
        },
      ]"
    ></vs-breadcrumb>

    <div class="mb-6">
      <vx-input-group class>
        <vs-input v-model="keyword" placeholder="输入商品关键词" />
        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button color="primary" @click="queryGoods">搜索商品</vs-button>
            <vs-button color="primary" @click="gotoNewData"
              >创建新商品</vs-button
            >
            <vs-button color="primary" @click="openImportNewData"
              >批量导入新商品</vs-button
            >
          </div>
        </template>
      </vx-input-group>
    </div>

    <div class="mb-6">
      <div class>
        <div class="mb-5">
          <template v-for="item in tabCategoryList">
            <vs-button
              :key="item.id"
              class="mr-1 mb-1"
              v-if="item.active"
              @click="queryGoodsByCategoryId(item.id)"
            >
              {{ item.name }}
              {{ item.status === 1 ? '' : '(已禁用)' }}</vs-button
            >
            <vs-button
              :key="item.id"
              class="mr-1 mb-1"
              v-else
              type="border"
              @click="queryGoodsByCategoryId(item.id)"
            >
              {{ item.name }}
              {{ item.status === 1 ? '' : '(已禁用)' }}</vs-button
            >
          </template>
        </div>

        <vs-table
          ref="table"
          :data="products"
          :max-items="itemsPerPage"
          :noDataText="noDataText"
          :stripe="true"
        >
          <template slot="thead">
            <vs-th width="120px">商品图片</vs-th>
            <vs-th width="11%">
              商品ID<br />
              所属分类<br />

              供货商
              <br />商品账册备案料号 <br />商品名称 <br />商品广告语
              <br />轮播&详情图
            </vs-th>

            <vs-th sort-key="order_status" width="8%">状态</vs-th>
            <vs-th sort-key="specs" width="18%">已添加的规格</vs-th>
            <vs-th sort-key="price" width="12%">
              采购价
              <br />单价 <br />团购 <br />市场价 <br />单位 <br />运费
              <br />免运费策略
            </vs-th>
            <vs-th> 操作 </vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :key="index" v-for="(tr, index) in data">
                <vs-td>
                  <image-item :item="tr">
                    <template slot="action-buttons">
                      <div class="flex flex-wrap">
                        <div
                          class="
                            item-view-primary-action-btn
                            p-3
                            flex flex-grow
                            items-center
                            justify-center
                            cursor-pointer
                          "
                          @click="uploadImage(tr.id, 1)"
                        >
                          <span class="text-sm font-semibold ml-2 text-primary"
                            >上传封面</span
                          >
                        </div>
                      </div>
                    </template>
                  </image-item>
                  <!-- <img :src="" class="w-full" /> -->
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate mb-1">
                    #{{ tr.id }}
                  </p>
                  <p
                    class="product-name font-medium truncate mb-1 text-primary"
                  >
                    {{ tr.category ? tr.category.name : '' }}
                  </p>
                  <p class="product-name font-medium truncate mb-1">
                    供货商: {{ tr.store ? tr.store.store_name : '未指定' }}
                  </p>
                  <p class="product-name font-medium truncate mb-1">
                    账册备案料号: {{ tr.itemNo }}
                  </p>
                  <p class="product-name font-medium truncate mb-1">
                    {{ tr.name }}
                  </p>
                  <p class="text-muted">{{ tr.slogan }}</p>
                  <p class="mt-3 font-small truncate">
                    <a
                      class="text-primary cursor-pointer"
                      @click="uploadImage(tr.id, 2, tr.swipers)"
                    >
                      {{ tr.swipers_count }}
                      张轮播图 </a
                    >,
                    <a
                      class="text-primary cursor-pointer"
                      @click="uploadImage(tr.id, 3, tr.images)"
                    >
                      {{ tr.images_count }}
                      张详情图
                    </a>
                  </p>
                </vs-td>

                <vs-td>
                  <ul class="con-s">
                    <li>
                      <div class="mb-1">
                        {{ Number(tr.status) === 1 ? '上架中' : '未上架' }}
                      </div>
                      <vs-switch
                        v-model="tr.status"
                        @input="changeSwitch(tr)"
                      />
                    </li>
                  </ul>
                </vs-td>
                <vs-td>
                  <div v-if="tr.spec" class="mb-1">
                    <div>
                      规格名称#{{ tr.spec.value }}
                      <a
                        href="javascript:void(0)"
                        @click="editSpec(tr.spec)"
                        class="mr-1 ml-1"
                        >修改</a
                      >
                      <a href="javascript:void(0)" @click="delSpec(tr.spec.id)"
                        >删除</a
                      >
                    </div>
                    <div class="mt-1">
                      <div class="mb-1">
                        规格值#
                        <a
                          href="javascript:void(0)"
                          @click="addSpecItem(tr.spec, tr.id)"
                          >添加</a
                        >
                      </div>
                      <div v-if="tr.specs.length > 0">
                        <vs-chip
                          class="mt-0"
                          color="primary"
                          v-for="item in tr.specs"
                          :key="item.id"
                          closable
                          @click="removeSpec(item, index)"
                          >{{ item.value }}</vs-chip
                        >
                      </div>
                    </div>
                  </div>
                  <div class v-else>
                    <p>
                      <a href="javascript:void(0)" @click="addSpec">添加规格</a>
                    </p>
                  </div>
                </vs-td>
                <vs-td>
                  <p class="mb-1">
                    <span class>采购价: {{ tr.purchase_price }}</span>
                  </p>
                  <p
                    class="product-price font-medium truncate text-danger mb-1"
                  >
                    单价: {{ tr.price }}
                  </p>
                  <p
                    class="product-price font-medium truncate text-danger mb-1"
                  >
                    是否团购: {{ tr.group_type === 2 ? '是' : '否' }}
                  </p>
                  <p
                    class="product-price font-medium truncate text-danger mb-1"
                    v-if="tr.group_type === 2"
                  >
                    团购价:{{ tr.group_price }}
                  </p>
                  <p
                    class="product-price font-medium truncate text-danger mb-1"
                    v-if="tr.group_type === 2"
                  >
                    团购人数: {{ tr.group_persons }}人团
                  </p>
                  <p v-if="tr.market_price" class="mb-1">
                    <span class="text-muted text-l-t"
                      >市场价: {{ tr.market_price }}</span
                    >
                  </p>
                  <p>单位: {{ tr.unit }}</p>
                  <p>运费: {{ tr.express }}</p>
                  <p v-if="tr.no_express_count > 0" class="text-danger">
                    购买 {{ tr.no_express_count }} 件免运费
                  </p>
                </vs-td>
                <vs-td class="whitespace-no-wrap items-center">
                  <div class="items-center">
                    <feather-icon
                      icon="ImageIcon"
                      svgClasses="w-5 h-5 hover:text-success stroke-current a-hover"
                      @click.stop="showPoster(tr, index)"
                      class="ml-2"
                    />
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current a-hover"
                      @click.stop="editData(tr, index)"
                      class="ml-2"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current a-hover"
                      class="ml-2"
                      @click.stop="deleteData(tr.id, tr.name, index)"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <vs-pagination
          :total="totalPage"
          v-model="currentx"
          @input="gotoCurrentPage"
          class="mt-6"
        >
        </vs-pagination>
      </div>
    </div>

    <!-- @cancel="cancelRowEditDetailHandler" -->
    <!-- @accept="confirmEdit" -->
    <!-- accept-text="确定"
      cancel-text="取消" -->
    <vs-popup
      classContent="showPopup"
      fullscreen
      title="编辑商品"
      :active.sync="editPopUpActive"
    >
      <vs-tabs color="rgba(115,103,240,1)" class="mb-10">
        <vs-tab label="商品信息">
          <template>
            <div class="vx-row mb-8">
              <div class="vx-col w-1/5 flex flex-row-reverse">
                <span>商品名称</span>
              </div>
              <div class="vx-col w-2/5">
                <vs-input class="" v-model="name" />
              </div>
            </div>
            <div class="vx-row mb-8">
              <div class="vx-col w-1/5 flex flex-row-reverse">
                <span>商品广告语</span>
              </div>
              <div class="vx-col w-2/5">
                <vs-input class="" v-model="slogan" />
              </div>
            </div>
            <div class="vx-row mb-8">
              <div class="vx-col w-1/5 flex flex-row-reverse">
                <span>商品分类</span>
              </div>
              <div class="vx-col w-2/5">
                <v-select
                  :options="categoryList"
                  label="name"
                  v-model="category"
                  :value="category ? category.name : ''"
                />
              </div>
            </div>
            <div class="vx-row mb-8">
              <div class="vx-col w-1/5 flex flex-row-reverse">
                <span>供货商</span>
              </div>
              <div class="vx-col w-2/5">
                <v-select
                  :options="merchantList"
                  label="name"
                  v-model="merchant"
                  :value="merchant ? merchant.name : ''"
                />
              </div>
            </div>
            <div class="vx-row mb-8">
              <div class="vx-col w-1/5 flex flex-row-reverse">
                <span>单价/市场价</span>
              </div>
              <div class="vx-col w-2/5">
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <vs-input
                      class=""
                      v-model="price"
                      type="number"
                      placeholder="单价"
                    />
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input
                      class=""
                      v-model="market_price"
                      type="number"
                      placeholder="市场价"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-8 mt-2">
              <div class="vx-col w-1/5 flex flex-row-reverse">
                <span>是否团购</span>
              </div>
              <div class="vx-col w-2/5">
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <ul class="con-s">
                      <li>
                        <!-- <div class="mb-1">{{group_type === 2?'团购':'非团购'}}</div> -->
                        <vs-switch
                          v-model="groupTypeCheck"
                          @input="changeGroupType(groupTypeCheck)"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-8" v-if="groupTypeCheck">
              <div class="vx-col sm:w-1/5 w-full flex flex-row-reverse">
                <span>团购价</span>
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      v-model="group_price"
                      type="number"
                      placeholder="团购价"
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      v-model="group_persons"
                      type="number"
                      placeholder="团购人数"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-8">
              <div
                class="
                  vx-col
                  sm:w-1/5
                  w-full
                  whitespace-no-wrap
                  flex flex-row-reverse
                "
                style="align-items: center"
              >
                <span class="whitespace-no-wrap" style="display: inline-block"
                  >单位/运费/采购价</span
                >
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      v-model="unit"
                      placeholder="单位"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      v-model="express"
                      placeholder="运费"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      v-model="purchase_price"
                      type="number"
                      placeholder="采购价"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-8">
              <div
                class="
                  vx-col
                  sm:w-1/5
                  whitespace-no-wrap
                  w-full
                  flex flex-row-reverse
                "
                style="align-items: center"
              >
                <span class="whitespace-no-wrap inline-block"
                  >满件数免运费</span
                >
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input v-model="no_express_count" type="number" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="vx-row flex justify-end mr-2">
            <vs-button
              color="primary"
              type="filled"
              class="mr-1 block"
              @click="editGoods_detail_Confirm"
              >保存</vs-button
            >
            <vs-button
              class="block"
              type="border"
              @click="
                editPopUpActive = false
                rowGoodPushObj = {}
              "
              >取消</vs-button
            >
          </div>
        </vs-tab>
        <vs-tab label="海关申报" style="height: 60vh">
          <template>
            <div class="vx-row w-full mb-2">
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">账册号&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.emsNo"
                    class="w-full"
                    placeholder="emsNo"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">账册备案料号&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.itemRecordNo"
                    class="w-full"
                    placeholder="itemRecordNo"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">企业商品名称&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.itemName"
                    class="w-full"
                    placeholder="itemName"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">商品编码&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.gcode"
                    class="w-full"
                    placeholder="gcode"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">商品名称&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.gname"
                    class="w-full"
                    placeholder="gname"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">商品规格型号&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.gmodel"
                    class="w-full"
                    placeholder="gmodel"
                  ></vs-input>
                </div>
              </div>
            </div>

            <div class="vx-row w-full mb-2">
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">条码&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.barCode"
                    class="w-full"
                    placeholder="barCode"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">原产国&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.country"
                    class="w-full"
                    placeholder="country"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">贸易国&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.tradeCountry"
                    class="w-full"
                    placeholder="tradeCountry"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">法定数量&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.qty1"
                    class="w-full"
                    placeholder="qty1"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">法定第二数量</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.qty2"
                    class="w-full"
                    placeholder="qty2"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">申报单位&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.unit"
                    class="w-full"
                    placeholder="unit"
                  ></vs-input>
                </div>
              </div>
            </div>

            <div class="vx-row w-full mb-2">
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">法定计量单位&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.unit1"
                    class="w-full"
                    placeholder="unit1"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">法定第二计量单位</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.unit2"
                    class="w-full"
                    placeholder="unit2"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">毛重(kg)&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.grossWeight"
                    class="w-full"
                    placeholder="grossWeight"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">净重(kg)&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.netWeight"
                    class="w-full"
                    placeholder="netWeight"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">代扣税率taxRate&nbsp;*</span>
                <div>
                  <v-select
                    :options="taxRateList"
                    label="name"
                    v-model="taxRateValue"
                    :value="taxRateValue ? taxRateValue.id : ''"
                  />
                </div>
              </div>
            </div>
            <div class="vx-row w-full mb-6">
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">货物单位（顺丰推单）</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.sfUnitName"
                    class="w-full"
                    placeholder="sfUnitName"
                  ></vs-input>
              </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">货物单价币别（顺丰推单）</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.sfCurrencyCode"
                    class="w-full"
                    placeholder="sfCurrencyCode"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">原产地国别（顺丰推单）</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.sfSourceAreaCode"
                    class="w-full"
                    placeholder="sfSourceAreaCode"
                  ></vs-input>
                </div>
              </div>
            </div>
          </template>
          <div class="vx-row flex justify-end mr-2">
            <vs-button
              color="primary"
              type="filled"
              class="mr-1 block"
              @click="editGoods_config_Confirm"
              >修改</vs-button
            >
            <vs-button
              class="block"
              type="border"
              @click="
                editPopUpActive = false
                rowGoodPushObj = {}
              "
              >关闭</vs-button
            >
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>

    <!-- 规格pop -->
    <vs-popup :title="popUpTitle" :active.sync="addSpecPopUpActive">
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">规格名称</label>
            <v-select
              :options="specs"
              taggable
              push-tags
              v-model="selectedSpec"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">规格值</label>
            <vs-input class="w-full" v-model="specValue" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="addSpecConfirm"
              >添加规格名称</vs-button
            >
            <vs-button type="border" @click="closeSpecPopUp">关闭</vs-button>
            <vs-alert :active="isShowMsg" class="mt-4">{{ msg }}</vs-alert>
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- 编辑规格pop -->
    <vs-popup :title="popUpTitle" :active.sync="editSpecPopUpActive">
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">规格名称</label>
            <v-select :options="specs" taggable push-tags v-model="spec" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              class="mr-3"
              :disabled="btnDisabled"
              @click="editSpecConfirm"
              >修改</vs-button
            >
            <vs-button
              type="border"
              :disabled="btnDisabled"
              @click="closeSpecPopUp"
              >关闭</vs-button
            >
            <vs-alert :active="isShowMsg" class="mt-4">{{ msg }}</vs-alert>
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- 删除此规格规格pop -->
    <vs-popup :title="popUpTitle" :active.sync="closeSpecPopUpActive">
      <div>
        删除规格名称, 会同时删除此规格名称下的所有规格值, 确定删除此规格内容?
      </div>
      <div class="flex mt-3">
        <vs-button
          class="mr-3"
          @click="confirmClearSpec"
          :disabled="btnDisabled"
          >确定删除</vs-button
        >
        <vs-button
          type="border"
          @click="cancelClearSpec"
          :disabled="btnDisabled"
          >取消</vs-button
        >
      </div>
    </vs-popup>

    <!-- 删除商品pop -->
    <vs-popup :title="popUpTitle" :active.sync="delPopUpActive">
      <div class>
        <div class="mb-4">是否确认删除商品: {{ curName }}?</div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="delConfirm" :disabled="btnDisabled"
              >确认删除</vs-button
            >
            <vs-button type="border" @click="closeDel" :disabled="btnDisabled"
              >关闭</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- 规格pop:  -->
    <vs-popup :title="popUpTitle" :active.sync="addSpecItemPopUpActive">
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">规格名称: {{ selectedSpec }}</label>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">规格值</label>
            <vs-input class="w-full" v-model="specItemValue" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              class="mr-3"
              @click="addSpecItemConfirm"
              :disabled="btnDisabled"
              >添加规格值</vs-button
            >
            <vs-button
              type="border"
              @click="closeAddSpecItem"
              :disabled="btnDisabled"
              >关闭</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- 导入pop -->
    <vs-popup :title="popUpTitle" :active.sync="importPopUpActive">
      <div>上传商品导入Excel</div>
      <div>
        <vs-alert active="true" class>支持的文件格式: xlsx</vs-alert>
        <div class>
          <vs-upload
            :action="uploadImportUrl"
            fileName="file"
            :data="uploadData"
            @on-success="successUpload"
            @on-error="showUploadError"
          />
        </div>
      </div>
    </vs-popup>

    <!-- 图片pop -->
    <vs-popup :title="popUpTitle" :active.sync="uploadImagePopUpActive">
      <div class="mb-3">上传商品{{ imageType }}</div>
      <div class="mb-6">
        <vs-alert :active="true" class>支持的文件格式: jpg, peng, png</vs-alert>
        <div class="b-a">
          <vs-upload
            :action="uploadImageUrl"
            fileName="file"
            :data="uploadImageData"
            @on-success="successUpload"
            @on-error="showUploadError"
          />
        </div>
      </div>
      <div v-if="uploadedImages.length > 0">
        <div class="mb-3">已上传的商品{{ imageType }}</div>
        <div>
          <div class="vx-row">
            <div
              class="vx-col sm:w-1/3 w-full flex mb-6"
              v-for="item in uploadedImages"
              :key="item.id"
            >
              <image-item :item="item">
                <template slot="action-buttons">
                  <div class="flex flex-wrap">
                    <div
                      class="
                        item-view-primary-action-btn
                        p-3
                        flex flex-grow
                        items-center
                        justify-center
                        cursor-pointer
                      "
                      @click="delImage(item.id, uploadImageData.type)"
                    >
                      <span class="text-sm font-semibold ml-2 text-primary"
                        >删除</span
                      >
                    </div>
                  </div>
                </template>
              </image-item>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- 海报pop -->
    <!-- <vs-popup
      classContent="showPosterPopup"
      title="分享海报"
      :active.sync="showPosterPopup"
      class="PosterPopup"
    >
    <div class='Poster'>
    <show-poster
      v-model="show_poster"
      :id="goodsId"
      :image="image"
      :price="price"
      :name="name"
      :qrCode="qrCode"
    ></show-poster>
    </div>
    </vs-popup> -->

    <vs-popup
      classContent="showPosterPopup"
      title="分享海报"
      :active.sync="showPosterPopup"
      class="PosterPopup"
    >
      <div class="ocj_poster">
        <div class="posterContainer">
          <show-poster
            :image="image"
            :price="price"
            :name="name"
            :qrCode="qrCode"
          ></show-poster>
        </div>
        <div class="separatorLine"></div>
        <div class="posterDownload boxloading" @click.stop="download">下载</div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import specsRepo from '@/repo/specs'
import EditDetail from './EditDetail.vue'
import goodsRepo from '@/repo/goods'
import taxRepo from '@/repo/tax'
import categoryRepo from '@/repo/category'
import merchantRepo from '@/repo/merchant'
import ImageItem from './components/ImageItem'
import vSelect from 'vue-select'
import ShowPoster from './components/ShowPoster'
import html2canvas from 'html2canvas'
export default {
  name: 'GoodsList',
  components: {
    EditDetail,
    'v-select': vSelect,
    ImageItem: ImageItem,
    ShowPoster,
  },
  data() {
    return {
      originTaxList: [],
      taxRateValue: {
        id: '',
        name: '',
      },
      taxRateList: [],
      rowGoodPushObj: {},
      keyword: '',
      page: 1,
      curCategoryId: 0,
      products: [],
      itemsPerPage: 10,
      totalPage: 0,
      maxPageNumber: 6,
      currentx: 1,
      noDataText: '',
      editPopUpActive: false,
      popUpActive: false,
      popUpTitle: '操作',
      popUpMsg: '',
      isShowMsg: false,
      msg: '',
      btnDisabled: false,
      addSpecPopUpActive: false,
      editSpecPopUpActive: false,
      closeSpecPopUpActive: false,
      showPosterPopup: false,
      importPopUpActive: false,
      uploadImagePopUpActive: false,
      addSpecItemPopUpActive: false,
      delPopUpActive: false,
      item: null,
      goodsId: 0,
      id: 0,
      name: '',
      slogan: '',
      purchase_price: '',
      price: '',
      market_price: '',
      group_type: 1,
      groupTypeCheck: false,
      group_price: 0,
      group_persons: 0,
      unit: '',
      express: '',
      no_express_count: '',
      categoryList: [],
      tabCategoryList: [],
      merchantList: [],
      uploadImageUrl: `${env.API_HOST}admin/goods/image/upload`,
      uploadData: null,
      uploadImportUrl: '/api/admin/goods/import',
      uploadImageData: {
        type: 1,
        goodsId: 0,
      },
      imageType: '图片',
      uploadedImages: [],
      uploadType: 1,
      image: '', //封面
      swipers: [], //轮播图
      images: [], //详情图
      spec: '',
      specs: [],
      showSpec: '',
      specValue: '',
      specItemValue: '',
      goodsSpecs: [],
      selectedSpec: null,
      category: {
        id: '',
        name: '',
        sort: '',
      },
      merchant: {
        id: '',
        name: '',
      },
      curIndex: 0,
      curName: '',
      curId: 0,
      qrCode: '',

    }
  },
  mounted() {
    this.noDataText = '加载中...'
    this.getGoodsList()
    this.getCategoryList()
    this.getSpecsList()
    this.getMerchantList()

    this.getTaxList()
  },
  computed: {
    groupTypeModel() {
      return this.group_type === 2
    },
  },
  methods: {
    close() {},
    showPoster(item, index) {
      this.showPosterPopup = true
      // this.show_poster = true
      try {
        this.image = item.image
        this.goodsId = item.goods_id
        this.name = item.name
        this.price = item.price
        this.qrCode = item.goods_wx_code_url
      } catch (error) {
        console.log(error)
      }
    },
    cancelRowEditDetailHandler() {
      this.editPopUpActive = false
      this.rowGoodPushObj = {}
    },
    //获取分类列表
    getCategoryList: function () {
      categoryRepo.list((error, data) => {
        if (data.code === 0) {
          const categoryList = data.data
          //console.log('category list:', categoryList)
          this.categoryList = categoryList
          const tabCategoryList = categoryList
          tabCategoryList.forEach((e) => {
            e.active = false
          })
          tabCategoryList.unshift({
            id: 0,
            name: '全部',
            active: true,
            status: 1,
          })
          this.tabCategoryList = tabCategoryList
          //console.log('tab category list:', tabCategoryList)
        }
      })
    },

    getMerchantList: function () {
      merchantRepo.getPullStoreList((error, data) => {
        const merchantList = data.data.map((v) => {
          return { id: v.id, name: v.store_name }
        })
        // const merchantList = data.data
        //console.log('merchantList list:', merchantList)
        this.merchantList = merchantList
      })
    },

    //获取规格列表
    getSpecsList: function () {
      specsRepo.list((error, data) => {
        if (data.length > 0) {
          const specs = []
          data.forEach((element) => {
            specs.push(element.name)
          })
          //console.log('specs:', specs)
          this.specs = specs
        }
      })
    },

    //查询商品
    queryGoods: function () {
      this.page = 1
      this.getGoodsList()
    },

    queryGoodsByCategoryId: function (categoryId) {
      this.curCategoryId = categoryId
      const tabCategoryList = this.tabCategoryList

      //console.log('tab:', tabCategoryList)
      this.tabCategoryList = tabCategoryList
      this.page = 1
      this.getGoodsList()
    },

    getGoodsList: function () {
      goodsRepo.list(
        this.page,
        this.keyword,
        this.curCategoryId,
        (error, data) => {
          //console.log('error', error)
          // console.log('商品列表', data)
          const list = data.data
          if (list.length === 0) {
            this.noDataText = '查询结果为空'
          }
          list.forEach((e) => {
            const specs = e.specs
            const spec = specs[0]
            e.spec = spec
            //去掉第一个元素
            specs.shift()
            e.specs = specs
          })
          //console.log('data:', list)
          this.products = list
          const total = data.total
          const perCount = data.per_page
          this.totalPage = Math.ceil(total / perCount)
          //console.log('total:', this.totalPage)
        }
      )
    },

    gotoCurrentPage: function () {
      this.page = this.currentx
      //console.log('this page:', this.page)
      this.getGoodsList()
    },

    gotoNewData: function () {
      this.$router.push({
        path: '/goods/add',
      })
    },

    changeGroupType: function (groupTypeCheck) {
      this.groupTypeCheck = groupTypeCheck
    },

    changeSwitch: function (e) {
      //当前修改的item
      //console.log('e:', e)
      let { id, status } = e
      status = status ? 1 : 0
      const statusName = status === 1 ? '上架' : '下架'
      goodsRepo.updateStatus(id, status, (error, data) => {
        // console.log(error)
        // console.log(data)
        // if (error) {
        //   this.openNotify('更新商品状态失败')
        // }
        if (data.code === 0) {
          this.openNotify(`商品${statusName}成功`, 'success')
        } else {
          this.openNotify(data.msg)
        }
        this.getGoodsList()
      })
    },

    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'bottom-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
    },

    getTaxList: function () {
      let that = this
      taxRepo.queryPullDown_list((error, resp) => {
        if (resp.code == 0) {
          that.originTaxList = resp.data
          if (Array.isArray(resp.data)) {
            let dealed_resp = resp.data.map((v) => {
              let obj = {}
              obj.id = v.id
              obj.name = v.name + ' ' + String(v.tax_rate) + '%'
              return obj
            })
            that.taxRateList = JSON.parse(JSON.stringify(dealed_resp))
          } else {
            that.openNotify('获取税率error')
          }
        } else {
          that.openNotify('获取税率error')
        }
      })
    },

    editData: function (item, index) {
      const {
        id,
        name,
        slogan,
        purchase_price,
        price,
        market_price,
        group_type,
        unit,
        group_price,
        group_persons,
        express,
        category,
        no_express_count,
        store_id,
      } = item
      this.merchant = this.merchantList.find((v) => v.id == store_id)
      this.id = id
      this.name = name
      this.slogan = slogan
      this.purchase_price = purchase_price
      this.price = price
      this.market_price = market_price
      this.group_type = group_type
      this.groupTypeCheck = this.group_type === 2 ? true : false
      this.group_price = group_price
      this.group_persons = group_persons
      this.express = express
      this.no_express_count = no_express_count
      this.unit = unit
      this.category = category

      let hhta = this

      goodsRepo.goodsConfDetail(hhta.id, (error, data) => {
        if (data.code == 0) {
          if (Array.isArray(data.data) && !data.data.length) {
            hhta.rowGoodPushObj = JSON.parse(JSON.stringify({}))
          } else {
            hhta.rowGoodPushObj = JSON.parse(JSON.stringify(data.data))
          }

          // hhta.rowGoodPushObj = JSON.parse(JSON.stringify(data.data))
          if (
            hhta.rowGoodPushObj &&
            hhta.rowGoodPushObj.taxRate &&
            hhta.rowGoodPushObj.taxRate.id
          ) {
            hhta.taxRateValue = {
              id: hhta.rowGoodPushObj.taxRate.id,
              name:
                hhta.rowGoodPushObj.taxRate.name +
                ' ' +
                hhta.rowGoodPushObj.taxRate.tax_rate +
                '%',
            }
          }
        } else {
          hhta.openNotify(data.msg)
        }
      })
      hhta.editPopUpActive = true
      hhta.curIndex = index
    },

    //打开删除模态框
    deleteData: function (id, name, index) {
      // console.log('index:', index)
      this.curName = name
      this.delPopUpActive = true
      this.curId = id
    },

    closeDel: function () {
      this.delPopUpActive = false
    },

    delConfirm: function () {
      const id = this.curId
      this.btnDisabled = true
      goodsRepo.delItem(id, (error, data) => {
        console.log(error)
        // console.log(data)
        this.delPopUpActive = false
        this.btnDisabled = false
        if (error) {
          this.openNotify('删除商品失败')
        }
        if (data.code === 0) {
          this.openNotify(data.msg, 'success')
          this.getGoodsList()
        } else {
          this.openNotify(data.msg)
        }
      })
    },

    //添加规格
    addSpec: function () {
      this.addSpecPopUpActive = true
      this.specValue = ''
    },

    //打开清空规格对话框
    clearSpec: function () {
      this.popUpActive = true
      this.popUpMsg = '是否清空已添加的规格?'
    },

    //关闭规格表单
    closeSpecPopUp: function () {
      this.editSpecPopUpActive = false
      this.addSpecPopUpActive = false
    },

    //删除规格
    delSpec: function (id) {
      // console.log('id:', id)
      this.closeSpecPopUpActive = true
      this.specId = id
    },

    //取消清空规格
    cancelClearSpec: function () {
      this.closeSpecPopUpActive = false
    },

    //确认清空规格
    confirmClearSpec: function () {
      this.btnDisabled = true
      const specId = this.specId
      //console.log('spec id:', specId)
      goodsRepo.delSpec(specId, (error, data) => {
        this.btnDisabled = false
        //console.log('del spec')
        if (error) {
          this.openNotify(data.msg)
        }
        if (data.code === 0) {
          this.openNotify(data.msg, 'success')
          this.closeSpecPopUpActive = false
          this.getGoodsList()
        }
      })
    },

    //确认添加规格
    addSpecConfirm: function () {
      const goodsSpecs = this.goodsSpecs
      const selectedSpec = this.selectedSpec
      //console.log('selected sepc:', selectedSpec)
      //console.log('specValue:', this.specValue)
      if (selectedSpec === null) {
        this.showAlert('请填写或选择一个规格名称')
      } else if (this.specValue === '') {
        this.showAlert('请填写一个规格值')
      } else {
        goodsSpecs.push(this.specValue)
        this.goodsSpecs = goodsSpecs
        localStorage.setItem('goodsSpecs', JSON.stringify(goodsSpecs))
        localStorage.setItem('selectedSpec', selectedSpec)
        this.specValue = ''
      }
    },

    //修改规格
    editSpec: function (spec) {
      this.editSpecPopUpActive = true
      this.spec = spec.value
      this.specId = spec.id
    },

    editSpecConfirm: function () {
      this.btnDisabled = true
      const specId = this.specId
      const spec = this.spec
      goodsRepo.editSpec(specId, spec, (error, data) => {
        console.log(error)
        // console.log(data)
        this.btnDisabled = false
        if (data.code === 0) {
          this.openNotify(data.msg, 'success')
          this.editSpecPopUpActive = false
          this.getGoodsList()
        } else {
          this.openNotify(data.msg)
        }
      })
    },

    //添加规格值
    addSpecItem: function (spec, goodsId) {
      this.selectedSpec = spec.value
      this.specId = spec.id
      this.addSpecItemPopUpActive = true
      this.goodsId = goodsId
      this.specItemValue = ''
    },

    closeAddSpecItem: function () {
      this.addSpecItemPopUpActive = false
    },

    addSpecItemConfirm: function () {
      this.btnDisabled = true
      const goodsId = this.goodsId
      const specId = this.specId
      const specItemValue = this.specItemValue
      goodsRepo.addSpecItem(goodsId, specId, specItemValue, (error, data) => {
        console.log(error)
        this.btnDisabled = false
        if (error) {
          this.openNotify('添加规格值失败')
        }
        // console.log('data', data)
        if (data.code === 0) {
          this.openNotify(data.msg, 'success')
          this.getGoodsList()
        } else {
          this.openNotify(data.msg)
        }
      })
    },

    //删除规格值
    delSpecItem: function (e) {
      const curItem = e.currentTarget.dataset.spec

      const goodsSpecs = this.goodsSpecs
      goodsSpecs.splice(
        goodsSpecs.findIndex((item) => item === curItem),
        1
      )
      this.goodsSpecs = goodsSpecs
      localStorage.setItem('goodsSpecs', JSON.stringify(goodsSpecs))
    },

    //显示错误alert
    showAlert: function (msg) {
      this.isShowMsg = true
      this.msg = msg
      setTimeout(() => {
        this.isShowMsg = false
        this.msg = ''
      }, 1000)
    },

    removeSpec: function (spec, index) {
      const itemSpecs = this.products[index].specs

      itemSpecs.splice(itemSpecs.indexOf(spec), 1)

      goodsRepo.delSpecItem(spec.id, (error, data) => {
        console.log(error)
        if (error) {
          this.openNotify('删除规格值失败')
        }
        if (data.code === 0) {
          this.openNotify(data.msg, 'success')
          this.getGoodsList()
        } else {
          this.openNotify(data.msg)
        }
      })
    },

    openImportNewData: function () {
      this.importPopUpActive = true
    },

    successUpload(event) {
      let responseText = event.currentTarget.responseText

      responseText = JSON.parse(responseText)
      this.openNotify(responseText.msg, 'success')
      //刷新
      this.getGoodsList()
    },

    showUploadError(event) {
      // console.log(event)
      if (event.currentTarget.status === 400) {
        let responseText = event.currentTarget.responseText

        responseText = JSON.parse(responseText)
        this.openNotify(responseText.msg)
      }
    },

    cancelImport: function () {
      this.importPopUpActive = false
    },

    confirmImport: function () {},

    uploadImage: function (id, type, images = []) {
      this.uploadedImages = []

      if (type === 1) {
        this.imageType = '封面'
      } else if (type === 2) {
        this.imageType = '轮播图'
      } else if (type === 3) {
        this.imageType = '详情图'
      }
      this.uploadImageData = {
        type: type,
        goodsId: id,
      }
      //打开模态
      this.uploadImagePopUpActive = true

      if (images.length > 0) {
        this.uploadedImages = images
      }
    },

    delImage: function (imageId, type) {
      // console.log('type:', type)
      let that = this
      goodsRepo.delImage(imageId, type, (error, data) => {
        if (data.code === 0) {
          this.openNotify(data.msg, 'success')
          this.getGoodsList()
          for (let a = 0; a < that.uploadedImages.length; a++) {
            if (that.uploadedImages[a].id == imageId) {
              that.uploadedImages.splice(a, 1)
              break
            }
          }
        } else {
          this.openNotify(data.msg)
          // console.log(that.uploadedImages)
        }
      })
    },

    submitConfigGoodsDetails: function () {
      const {
        emsNo,
        itemRecordNo,
        itemName,
        gcode,
        gname,
        gmodel,
        barCode,
        country,
        tradeCountry,
        qty1,
        qty2,
        unit,
        unit1,
        unit2,
        grossWeight,
        netWeight,
      } = this.rowGoodPushObj
      if (
        grossWeight &&
        netWeight &&
        unit1 &&
        unit &&
        qty1 &&
        tradeCountry &&
        country &&
        barCode &&
        gmodel &&
        gname &&
        gcode &&
        itemName &&
        itemRecordNo &&
        emsNo
      ) {
        this.rowGoodPushObj.netWeight = Number(this.rowGoodPushObj.netWeight)
        this.rowGoodPushObj.taxRate = String(this.taxRateValue.id)
        delete this.rowGoodPushObj.id
        delete this.rowGoodPushObj.goods_id
        let that = this

        goodsRepo.goodsConf(that.id, that.rowGoodPushObj, (error, data) => {
          if (data.code == 0) {
            that.editPopUpActive = false
            that.openNotify(data.msg, 'success')
            that.getGoodsList()
          } else {
            that.openNotify(data.msg)
          }
        })
      } else {
        let s_array = [
          'emsNo',
          'itemRecordNo',
          'itemName',
          'gcode',
          'gname',
          'gmodel',
          'barCode',
          'country',
          'tradeCountry',
          'qty1',
          'qty2',
          'unit',
          'unit1',
          'unit2',
          'grossWeight',
          'netWeight',
        ]
        for (let i = 0; i < s_array.length; i++) {
          const element = s_array[i]
          if (
            this.rowGoodPushObj[element] == undefined ||
            String(this.rowGoodPushObj[element]).trim() == ''
          ) {
            this.openNotify(`${element}为必填项，请完善推单设置表单`)
            break
          }
        }
        return
      }
    },

    /**
     * @description 商品row->pop->确定
     */
    editGoods_detail_Confirm: function () {
      const id = this.id
      const name = this.name
      const slogan = this.slogan
      const purchase_price = this.purchase_price
      const price = this.price
      const category_id = this.category ? this.category.id : 0
      const merchant_id = this.merchant ? this.merchant.id : 0
      const no_express_count = this.no_express_count ? this.no_express_count : 0
      const market_price = this.market_price
      const unit = this.unit
      const group_type = this.groupTypeCheck ? 2 : 1
      const group_price = this.group_price
      const group_persons = this.group_persons

      const express = this.express
      const updateData = {
        name: name,
        slogan: slogan,
        unit: unit,
        purchase_price: purchase_price,
        price: price,
        market_price: market_price,
        category_id: category_id,
        store_id: merchant_id,
        express: express,
        no_express_count: no_express_count,
        group_type: group_type,
        group_price: group_price,
        group_persons: group_persons,
      }
      if (this.groupTypeCheck) {
        if (Number(group_price) === 0) {
          this.openNotify('团购价格不能为0')
        } else if (Number(group_price) >= Number(price)) {
          this.openNotify('团购价格需小于零售价格')
        } else if (group_persons === '' || group_persons < 2) {
          this.openNotify('需设置团购人数且大于1')
        } else {
          let that = this
          goodsRepo.update(id, updateData, (error, data) => {
            if (data.code === 0) {
              that.openNotify(data.msg, 'success')
              that.editPopUpActive = false
              // that.submitConfigGoodsDetails(id)
              that.getGoodsList()
            } else {
              that.openNotify(data.msg)
            }
          })
        }
      } else {
        let that = this
        goodsRepo.update(id, updateData, (error, data) => {
          if (data.code === 0) {
            that.openNotify(data.msg, 'success')
            that.editPopUpActive = false
            // that.submitConfigGoodsDetails(id)
            that.getGoodsList()
          } else {
            that.openNotify(data.msg)
          }
        })
      }
    },

    editGoods_config_Confirm: function () {
      this.submitConfigGoodsDetails()
    },

    //海报下载
    download() {
      var to_img = document.querySelector('.toimg')
      html2canvas(to_img, {
        useCORS: true,
        imageTimeout: 1000,
        scale: 5,
        scrollX: 0,
        scrollY: 0,
      }).then((canvas) => {
        var imgUrl = canvas.toDataURL('image/png') // 将canvas转换成img的src流
        this.imgSrc = imgUrl
        const alink = document.createElement('a')
        alink.setAttribute('href', imgUrl) //如果使用canvas，那么把imgSrc改为canvas
        alink.download = this.name + '.png'
        alink.click()
        document.body.removeChild(alink)
      })
    },
  },
}
</script>
<style lang="scss">
// .popup_goods_configs .con-vs-popup .vs-popup {
//   width: 903px !important;
// }

// .showPosterPopup .con-vs-popup .vs-popup {
//   width: 903px !important;
//   height: 500px !important;
// }

.con-vs-dialog {
  .vs-dialog {
    max-width: 82vw;
  }
}
// .product_goods_list .vs-dialog .vs-dialog-text .con-slot-tabs .vs-tabs--content{
//   height: 70vh !important;
// }
.product_goods_list .product-img {
  width: 0px;
}

.product_goods_list .text-muted {
  color: #999;
}

.product_goods_list .text-l-t {
  text-decoration-line: line-through;
}

.product_goods_list .a-hover {
  cursor: pointer;
}

.product_goods_list .clear {
  display: inline-block;
  clear: both;
}

.product_goods_list .b-a {
  border: 1px solid #f5f5f5;
}

.testdiv {
  margin: 0 auto;
  width: 100px;
  height: 100px;
  background-color: aqua;
}
</style>


<style lang="scss" scoped>
.PosterPopup ::v-deep .showPosterPopup {
  // margin: 0 !important;
  width: 35vw;
  padding: 0;
  height: 79.7778vh !important;
  min-width: 250px !important;
  position: relative !important;
  margin: 0;
}

.PosterPopup ::v-deep .vs-popup {
  width: 35vw;
  height: calc(79.7778vh + 36.156px) !important;
  min-width: 250px !important;
}
.ocj_poster {
  height: 79.7778vh;
  width: 100%;
  min-width: 230px;
  display: inline-block;
  position: relative !important;
  .posterContainer {
    width: 37vh;
    height: 65.7778vh;
    position: absolute;
    top: 2.5vh;
    left: calc((100% - 37vh) / 2);
    border: none;
  }
  .separatorLine {
    width: 100%;
    height: 0px;
    // margin-top: 3vh;
    position: absolute;
    top: 70.7778vh;
    border: 1px solid #f2f2f2;
    border-width: 0 0 2px 0;
    transform: scaleY(0.5);
  }
}
.posterDownload {
  width: 10vh;
  height: 5vh;
  position: relative;
  top: 72.7778vh;
  margin-left: auto;
  margin-right: 20px;
  background-color: rgba(115, 103, 240, 1);
  border-radius: 5px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0.4px;
  text-align: center;
  line-height: 5vh;
  &:hover {
    cursor: pointer;
    box-shadow: 0 5px 10px rgba(115, 103, 240, 0.5);
  }
}
</style>
